import { ReactNode, MutableRefObject, useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import { X } from 'lucide-react';

import { CustomEvents } from '@labradorsports/constants';

import ErrorBoundary from '../../../main/error-boundary/error-boundary.js';

interface Props {
    className?: string;
    /** Should always be a Panel */
    left?: ReactNode;
    /** Should always be a Panel */
    right?: ReactNode;
    leftClassName?: string;
    rightClassName?: string;
    toolbarButtons?: ReactNode;
    leftControlRef?: MutableRefObject<{
        isOpen: () => boolean;
    }>;
    onCatch?: () => any;
}

const PageLayout: FC<Props> = ({ className, left, right, leftClassName, rightClassName, leftControlRef, onCatch }) => {
    const [showMenu, setShowMenu] = useState(false);

    const open = () => setShowMenu(true);
    const close = () => setShowMenu(false);

    useEffect(() => {
        window.addEventListener(CustomEvents.LEFT_PANEL_OPEN, open);
        window.addEventListener(CustomEvents.LEFT_PANEL_CLOSE, close);

        return () => {
            window.removeEventListener(CustomEvents.LEFT_PANEL_OPEN, open);
            window.removeEventListener(CustomEvents.LEFT_PANEL_CLOSE, close);
        };
    }, []);

    if (leftControlRef) {
        // Use an window event listener instead of ref?
        leftControlRef.current = {
            isOpen: () => showMenu,
        };
    }

    const classNames = ['page-layout', className ?? ''];

    const leftClassNames = ['left-panel', leftClassName ?? ''];

    if (left === undefined) {
        leftClassNames.push('hidden');
        classNames.push('no-left');
    } else if (showMenu) {
        leftClassNames.push('shown');
    }

    return (
        <ErrorBoundary onCatch={onCatch}>
            <div className={classNames.join(' ')}>
                <div className={leftClassNames.join(' ')}>
                    <IconButton className="close-button" onClick={close}>
                        <X />
                    </IconButton>
                    {left}
                </div>
                <div className={`right-panel ${rightClassName ?? ''}`}>{right}</div>
            </div>
        </ErrorBoundary>
    );
};

export default PageLayout;
